/* Akoya – Einblenden beim Scrollen.

   - schaltet das Verstecken erst ein, wenn JavaScript laeuft
   - staffelt Elemente derselben Reihe (Produktkacheln, Kacheln, Galerie)
   - beobachtet auch nachgeladene Inhalte (Filter, Infinite Scroll)
   - respektiert prefers-reduced-motion und hat eine Not-Bremse nach 3s */

(function () {
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) return;

  root.classList.add('akoya-motion');

  var SELECTORS = [
    '.akoya-reveal',
    '.product-grid__item',
    '.resource-list__item',
    '.akoya-collection-hero__inner > *',
    '.akoya-gender-tile',
    '.akoya-gallery-item',
    '.akoya-story-visual',
    '.akoya-story-text'
  ].join(',');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  function stagger(element, index) {
    if (element.style.transitionDelay) return;
    var step = Math.min(index, 5) * 0.07;
    element.style.setProperty('--akoya-reveal-delay', step + 's');
  }

  function prepare(scope) {
    var elements = (scope || document).querySelectorAll(SELECTORS);
    var groups = new Map();

    elements.forEach(function (element) {
      if (element.dataset.akoyaRevealReady) return;
      element.dataset.akoyaRevealReady = 'true';
      element.setAttribute('data-akoya-reveal', '');

      var parent = element.parentElement || document.body;
      var index = groups.get(parent) || 0;
      groups.set(parent, index + 1);
      stagger(element, index);

      observer.observe(element);
    });
  }

  function start() {
    prepare(document);

    // Nachgeladene Inhalte (Filter, weitere Produkte) mitnehmen
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          prepare(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // Not-Bremse: falls etwas haengt, nach 3s alles zeigen
    window.setTimeout(function () {
      document.querySelectorAll('[data-akoya-reveal]:not(.in)').forEach(function (element) {
        element.classList.add('in');
      });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();